import { ReactElement, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'utils/is-mobile';
import { Game, MarketGroupItem } from 'interfaces/sportsbook-data-levels';
import { MarketRow } from './MarketRow';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import './index.less';

type TMarketsGroupItemsProps = {
  data: Array<MarketGroupItem>;
  game: Game;
  competitionName: string;
  sportName: string;
  menu: string;
  currentSport?: string;
  sport?: string;
  gameId?: number;
  isAllCollapsed?: boolean;
  handleShowMoreClick?: () => void;
};

const INITIAL_COUNT = 3;

export const MarketsGroupItemsNoLazy = ({
  data,
  currentSport,
  sport,
  gameId,
  isAllCollapsed,
  handleShowMoreClick,
  game,
  competitionName,
  sportName
}: TMarketsGroupItemsProps): ReactElement => {
  const configs = useSportsbookConfigs();

  const changedMarketsRef = useRef<Record<string, boolean>>({});
  const [marketGroups, setMarketGroups] = useState(
    data.slice(0, INITIAL_COUNT)
  );

  const { t } = useTranslation();

  useEffect(() => {
    Object.keys(changedMarketsRef.current)?.forEach(group => {
      const getMarketGroup: MarketGroupItem | undefined = data.find(
        updateGroup => updateGroup.type === group
      );

      if (getMarketGroup) {
        getMarketGroup.notCompact = changedMarketsRef.current[group];
      }
    });

    if (configs.fixedScroll && !isMobile()) {
      setMarketGroups(data);
    } else if (data.length <= marketGroups.length) {
      setMarketGroups(data.slice(0, marketGroups.length));
    } else {
      setMarketGroups(data.slice(0, INITIAL_COUNT));
    }
  }, [data]);

  const toggleCompact = (key: string, active: boolean) => {
    const group: MarketGroupItem | undefined = marketGroups.find(
      group => group.type === key
    );

    if (group) {
      changedMarketsRef.current = {
        ...changedMarketsRef.current,
        [group.type]: active
      };

      group.notCompact = active;

      setMarketGroups([...marketGroups]);
    }
  };

  return (
    <>
      {marketGroups.map((group, index) => (
        <MarketRow
          isAllCollapsed={isAllCollapsed}
          sport={sport}
          gameId={gameId}
          group={group}
          Index={index}
          key={index}
          currentSport={currentSport}
          toggleCompact={notCompact => toggleCompact(group.type, notCompact)}
          competitionName={competitionName}
          sportName={sportName}
          game={game}
        />
      ))}
      <div className="showMoreLessMarkets">
        <div
          className="showMoreLessMarkets__button"
          onClick={handleShowMoreClick}
        >
          {t('sportsbook.showMoreMarkets')}
        </div>
      </div>
    </>
  );
};
